// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_Tnb","legend":"e_Unb","legendContent":"e_Vnb","contentWrapper":"e_Wnb","fieldsetContent":"e_Xnb"};